工人管理
<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchInfo.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchInfo.workerName" placeholder="请输入姓名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='addWorker' type="primary" icon='el-icon-plus'
      v-show="$ButtonShow('YHW_ADD_01')">新增工人</el-button>
    <el-button class="mb20" @click='isShowImport = true' type="primary" v-show="$ButtonShow('YHW_ADD_02')">
      <div class="importExport">
        <i class="iconfont icon-icon_obj_daoru"></i>
        <span>导入数据</span>
      </div>
    </el-button>
    <el-table class="global-table" stripe :data="tableData" v-loading="loading">
      <template v-for="(item, index) in itemList">
        <el-table-column v-if="item.prop === 'projectName'" show-overflow-tooltip :label="item.label" :key="index">
          <template v-slot="{ row }">
            <span>{{ row.projectState === '3' ? getState(row.projectState) + '—' + row.projectName :
              row.projectName}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.prop === 'workerCard'" :label="item.label" :key="index">
          <template v-slot="{ row }">
            {{ row.workerCard ? row.workerCard.substring(0, 3) + '***********' +
              row.workerCard.substring(row.workerCard.length - 4, row.workerCard.length) : ''}}
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.prop === 'deviceStatus'" show-overflow-tooltip :label="item.label" :key="index">
          <template v-slot="{ row }">
            <span>{{ row.deviceStatus === '1' ? '在线' : row.deviceStatus === '2' ? '离线' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else :label="item.label" :prop="item.prop" show-overflow-tooltip
          :key="index"></el-table-column>
      </template>
      <el-table-column label="操作" width="240px" fixed="right">
        <template v-slot="{ row }">
          <el-button v-show="$ButtonShow('YHW_PLAY_01') && row.deviceNumber" type="text" @click="onPlay(row)">轨迹回放</el-button>
          <el-button v-show="$ButtonShow('YHW_Bind_01')" type="text" @click="onBind(row)">绑定/更换设备</el-button>
          <el-button type="text" @click="$router.push(`/laborManageList/worker/edit${row.workerId}`)"
            v-show="$ButtonShow('YHW_EDT_01') && row.projectState !== '3'">编辑</el-button>
          <el-button :class="row.projectState === '3' ? 'marLeft' : ''" type="text" @click="deleteConfirm(row)"
            v-show="$ButtonShow('YHW_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="getList"
      @size-change="getList"></GlobalPagination>
    <!-- 导入工人 -->
    <ImportData :isShowImport.sync="isShowImport" :isNeedProject="true" :importUrl="$apis.worker.importProjectWorker"
      :tempUrl="'https://qn.maintain.base.gintell.cn/template/工人导入模板.xlsx'" templateKey="workerImportTemplate"
      @onSuccess="onSearch"></ImportData>
      <Bind :dialogVisible.sync="isShowBind" :info="info" @success="onSearch"></Bind>
  </el-card>
</template>

<script>
import ImportData from '@/components/importTemplateData/Index.vue'
import Bind from './Bind.vue'

// @KeepAlive
export default {
  name: 'projectWorkerList',
  components: { ImportData, Bind },
  data () {
    return {
      searchInfo: {
        projectId: '',
        workerName: ''
      },

      itemList: [
        {
          label: '所属项目',
          prop: 'projectName'
        },
        {
          label: '工人姓名',
          prop: 'workerName'
        },
        {
          label: '身份证号',
          prop: 'workerCard'
        },
        {
          label: '年龄',
          prop: 'workerAge'
        },
        {
          label: '性别',
          prop: 'workerSexName'
        },
        {
          label: '家庭住址',
          prop: 'homeAddress'
        },
        {
          label: '联系电话',
          prop: 'workerMobile'
        },
        {
          label: '设备编号',
          prop: 'deviceNumber'
        },
        {
          label: '设备状态',
          prop: 'deviceStatus'
        }
      ],
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      isShowImport: false,
      isShowBind: false,
      info: {}
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },

  created () {
    this.getList()
  },
  methods: {
    // 搜索
    onSearch () {
      this.page = 1
      this.getList()
    },

    // 获取列表数据
    getList () {
      this.loading = true
      this.$axios.get(this.$apis.worker.selectYhWorkerByPage,
        {
          ...this.searchInfo,
          page: this.page,
          size: this.size
        }).then(res => {
        this.total = res.total
        this.tableData = res.list
      }).finally(() => {
        this.loading = false
      })
    },

    getState (state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    },

    // 新增工人
    addWorker () {
      this.$router.push({ name: 'projectWorkerAdd' })
    },

    // 删除工人
    deleteConfirm (row) {
      this.$confirm(`是否删除工人【${row.workerName}】?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.worker.deleteYhWorker,
          {
            workerId: row.workerId
          }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },


    onBind (row) {
      this.info = row
      this.isShowBind = true
    },

    onPlay (row) {
      this.$router.push({
        name: 'workPlay',
        params: {
          workerId: row.workerId,
          projectId: row.projectId
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
.marLeft {
  margin-left: 0px;
}
  .iconfont {
    font-size: 12px;
    margin-right: 8px;
  }
</style>
